module.exports = __webpack_public_path__ + "static/media/banner-brios-feria-empresarial-la-montana-10.7f86dd34.webp";